/* oxlint-disable */
/**
 * Sends fingerprint data to the backend for user tracking and security purposes
 * @param visitorId - The unique visitor ID from FingerprintJS
 * @param userId - The authenticated user's ID
 * @param confidence - The confidence score from FingerprintJS
 * @returns Promise<boolean> - Success status
 */
export const sendFingerprintToBackend = async (
  visitorId: string,
): Promise<boolean> => {
  try {
    const response = await fetch('/api/auth/fingerprint', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fingerprint: visitorId,
      }),
    });

    if (!response.ok) {
      console.error('Failed to send fingerprint data:', response.statusText);
      return false;
    }

    const result = await response.json();
    console.log('✅ Fingerprint data sent successfully:', result);
    return true;
  } catch (error) {
    console.error('❌ Error sending fingerprint data:', error);
    return false;
  }
};

/**
 * Validates if fingerprint data should be captured
 * @param session - Next-auth session object
 * @param account - User account from store
 * @param isCaptured - Whether fingerprint was already captured
 * @returns boolean - Whether to proceed with capture
 */
export const shouldCaptureFingerprint = (
  session: any,
  account: any,
  isCaptured: boolean,
): boolean => {
  return !!(
    session?.user?.id
    && account?.email
    && !isCaptured
  );
};
